var React = require('react');

function FacebookRoundInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M20.5 10.06c0-5.54-4.477-10.029-10-10.029s-10 4.49-10 10.03c0 5.007 3.656 9.156 8.438 9.908v-7.01h-2.54v-2.898h2.54V7.85c0-2.513 1.492-3.902 3.777-3.902 1.094 0 2.238.196 2.238.196v2.468h-1.262c-1.242 0-1.629.774-1.629 1.567v1.88h2.774l-.443 2.9h-2.33v7.009c4.78-.752 8.437-4.901 8.437-9.908Z"}));
}

FacebookRoundInline.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 21 20"};

module.exports = FacebookRoundInline;

FacebookRoundInline.default = FacebookRoundInline;
